import { render, staticRenderFns } from "./BaseExtraction.vue?vue&type=template&id=34edeed5"
import script from "./BaseExtraction.vue?vue&type=script&lang=js"
export * from "./BaseExtraction.vue?vue&type=script&lang=js"
import style0 from "./BaseExtraction.vue?vue&type=style&index=0&id=34edeed5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports